import { ComponentsOverrides, lighten, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";
import hexToRGBA from "../../../hexToRGBA";

//Note: Cannot be named switch (reserved keyword)
const muiSwitch = ({ palette, spacing, gradients }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiSwitch"] => ({
    root: {
        padding: spacing(0.75),
        width: spacing(10.25),
        height: undefined,
    },
    track: {
        opacity: 1,

        height: spacing(4),
        borderRadius: spacing(4),
        transition: `background 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
        backgroundColor: palette.darkBlue,
        background: `radial-gradient(circle at 0% 0%, ${palette.veryDarkBlue} 0%, ${palette.darkBlue} 100%)`,
    },
    colorPrimary: {
        "&.Mui-checked": {
            color: palette.white,
            "&&": {
                "&:hover": {
                    backgroundColor: hexToRGBA(palette.primary, 0.09),
                },
            },
            "& + .MuiSwitch-track": {
                background: `${gradients.switchGradient}`,
                opacity: 1,
            },
        },

        "&.Mui-disabled": {
            color: palette.white,
            "& + .MuiSwitch-track": {
                background: `${palette.grey40}`,
                opacity: 1,
            },
            "&.Mui-checked": {
                color: palette.white,
                "& + .MuiSwitch-track": {
                    background: `${lighten(palette.primary, 0.65)}`,
                },
            },
        },
    },
    thumb: {
        height: spacing(3.25),
        width: spacing(3.25),
        boxShadow: "0 0 0.6rem rgba(0, 0, 0, 0.11), 0 0.2rem 0.7rem rgba(0, 0, 0, 0.06), 0 0.501331rem 0.793775rem rgba(0, 0, 0, 0.2)",
    },
    switchBase: {
        borderRadius: "100%",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.06)",
        },
        "&.Mui-checked": {
            "&&": {
                "&:hover": {
                    backgroundColor: hexToRGBA(palette.lightPrimary, 0.09),
                },
            },
            transform: `translateX(${spacing(4.75)})`,
            "& + .MuiSwitch-track": {
                background: `${gradients.switchGradient}`,
                opacity: 1,
            },
        },
        "&:disabled": {
            "& + .MuiSwitch-track": {
                background: `${palette.grey40}`,
                opacity: 1,
            },
            "&.Mui-checked": {
                "& + .MuiSwitch-track": {
                    background: `${lighten(palette.lightPrimary, 0.65)}`,
                },
            },
        },
    },
});

export default muiSwitch;
